import ThirdPartyMessageDispatcher from "./ThirdPartyMessageDispatcher";
export default class ThirdPartyBrowserLocationUtils {
    static updateBrowserLocationHash(newHash, targetOrigin) {
        // Update location
        window.location.hash = newHash;
        // Dispatch update to the parent
        ThirdPartyBrowserLocationUtils.dispatchLocationChangeMessage(window.location, targetOrigin);
    }
    static updateBrowserLocation(newPath, newSearch = '', newHash = '', targetOrigin) {
        const newLocation = {
            pathname: newPath,
            search: newSearch,
            hash: newHash
        };
        ThirdPartyBrowserLocationUtils.dispatchLocationChangeMessage(newLocation, targetOrigin);
    }
    static updateBrowserLocationWithPush(newPath, history, targetOrigin) {
        history.push(newPath);
        ThirdPartyBrowserLocationUtils.dispatchLocationChangeMessage(window.location, targetOrigin);
    }
    static updateBrowserLocationWithReplace(newPath, history, targetOrigin) {
        history.replace(newPath);
        ThirdPartyBrowserLocationUtils.dispatchLocationChangeMessage(window.location, targetOrigin);
    }
    static updateBrowserLocationWithPushAndNoSectionChange(newPath, history, targetOrigin) {
        history.push(newPath);
        const tempUrl = new URL(window.location.origin + newPath);
        ThirdPartyMessageDispatcher.dispatchMessage('location_change_no_section_change', targetOrigin, {
            location: {
                pathname: tempUrl.pathname,
                search: tempUrl.search,
                hash: tempUrl.hash
            }
        });
    }
    static dispatchLocationChangeMessage(location, targetOrigin) {
        ThirdPartyMessageDispatcher.dispatchMessage('location_change', targetOrigin, {
            location: {
                pathname: location.pathname,
                search: location.search,
                hash: location.hash
            }
        });
    }
}
//# sourceMappingURL=ThirdPartyBrowserLocationUtils.js.map